import { Link } from "react-router-dom";
import { FaApple } from "react-icons/fa";
import Mark from "./Mark";
import Shell from "./Shell";
import {
  NIGHTDRIFT_APP_STORE_URL,
  SUPPORT_EMAIL,
  YEARLY_PRODUCT_ID,
} from "./constants";

function Main() {
  return (
    <Shell>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white shadow rounded-lg p-6">
          <Mark />
          <h2 className="text-xl font-bold text-gray-900">Nightdrift</h2>
          <p className="text-gray-700 mt-4">
            Nightdrift is a sleep sounds app for iPhone. Long sounds loop seamlessly, so rain, thunderstorms, wind, ocean waves, water, brown noise, pink noise, white noise, and ambient beds do not click when they repeat. The Frequencies category is a set of calming tones, each labeled by mood. Mix more than one sound, set the volume of each, and save the mixes you want again.
          </p>
          <p className="text-gray-700 mt-4">
            A gentle sleep timer draws the time remaining on a countdown ring and fades the sound out. Playback continues in the background, with controls on the Lock Screen. The app is a dark, starry night: near-black, with amber crescent-moon accents. The icon is an amber crescent moon with waves dissolving to the right.
          </p>
          <p className="text-gray-700 mt-4">
            Nightdrift Premium is an auto-renewable yearly subscription ({YEARLY_PRODUCT_ID}): 7 days free, then $0.99 USD per year. The trial converts to a paid year unless you cancel at least 24 hours before it ends. There is no account to create. Read the{" "}
            <Link to="/nightdrift/terms" className="text-blue-500 hover:text-blue-600">Terms of Use</Link>
            {" "}and{" "}
            <Link to="/nightdrift/privacypolicy" className="text-blue-500 hover:text-blue-600">Privacy Policy</Link>.
          </p>
          <div className="mt-6 flex items-center">
            <a
              href={NIGHTDRIFT_APP_STORE_URL}
              className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-blue-500 hover:bg-blue-600"
            >
              <FaApple className="mr-2" />
              Download on the App Store
            </a>
          </div>
        </div>

        <div className="bg-white shadow rounded-lg p-6">
          <h2 className="text-xl font-bold text-gray-900">Contact Support</h2>
          <p className="text-gray-700 mt-4">
            Our goal is to help you drift off peacefully. For any questions, suggestions, or feedback then please reach out at the email address below.
          </p>
          <div className="mt-6 flex items-center">
            <a href={"mailto:" + SUPPORT_EMAIL} className="text-blue-500 hover:text-blue-600">{SUPPORT_EMAIL}</a>
          </div>
          <p className="text-gray-700 mt-4">
            Common questions about restoring a purchase, the free trial, cancelling, and background playback are on the{" "}
            <Link to="/nightdrift/support" className="text-blue-500 hover:text-blue-600">support page</Link>.
          </p>
        </div>
      </div>
    </Shell>
  );
}

export default Main;
